<template>
    <div class="content-wrapper">
        <div class="content-body">
            <div class="auth-inner p-md-3">
                <div class="card mb-0">
                    <div class="card-body">
                        <div class="container" v-if="dynamicLoaded">
                            <div>
                                <component :is="dynamicData"></component>
                            </div>
                            <div ref="htmlDocument" hidden>
                                <component :is="dynamicData"></component>
                                <h3>Electronic Signature</h3>
                                <div class="">
                                    <div class="signature_item">
                                        <div>
                                            <img v-bind:src="signature" style="width:auto;height:200px"/>
                                            <div style="border-bottom: 1px solid;
                                            width: 300px;
                                            margin-bottom: 9px;"></div>
                                        </div>
                                        <div class="">
                                            Signature (If applicable)
                                        </div>

                                    </div>
                                </div>
                                <div>
                                    <p> Date Signed: <strong>{{ today }}</strong></p>
                                </div>

                            </div>
                            <Vue3Signature  ref="signature1" :sigOption="state.option" :w="'100%'" :h="'350px'" :disabled="state.disabled" class="signature" @mouseleave="handleMouseLeave('image/jpeg')"></Vue3Signature>
                            <button class="btn btn-success mt-1 mr-1" v-if="isSavingInfo">Saving...</button>
                            <button @click="save('image/jpeg')" class="btn btn-success mt-1 mr-1" v-else>Save</button>
                            <button @click.once="clear" class="btn btn-outline-success mt-1 mr-1" :key="signatureKey">Clear</button>
                            <button @click="undo" class="btn btn-outline-info mt-1 mr-1">Undo</button>


                        </div>
                        <li v-else class="d-flex align-items-center justify-content-center">
                            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                            <span class="ml-25 align-middle">Loading Agreement...</span>
                        </li>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { useBusinessStore } from "../../stores/BusinessStore.js";
  import { useUserStore } from "../../stores/UserStore.js";
  import { useRoute, useRouter } from "vue-router";
  import { ref, reactive} from "vue";
  import moment from 'moment';
  import axios from "axios";

  export default {
    name: "ContractInfoComponent",
    setup() {
      const route = useRoute();
      const router = useRouter();
      const routerName = route.name;
      const clientAgreementData = reactive({});
      const dynamicData = ref({});
      const dynamicLoaded = ref(false);

      const businessStore = useBusinessStore();
      const userStore = useUserStore();
      const type = !userStore.user.is_contract_signed ? 1 : 2;
      const today =  ref(moment().format('LL'));
      const signature1 = ref(null);
      const htmlDocument = ref();
      const signature =ref();
      const isSavingInfo = ref(false),
      signatureKey = ref(0);
      const state = reactive({
            count: 0,
            option: {
                penColor: "rgb(0, 0, 0)",
                backgroundColor: "rgb(255,255,255)"
            },
            disabled: false
       })
      const fetchServiceAgreement = async () => {

        let uri = !userStore.user.is_contract_signed ? "contract-info" : 'power-of-attorney';
        const route = router.resolve({
          name: uri,
        });

        try {
          const { data } = await axios.get(route.href);
          if (!data.error) {
            if (data.data.service_agreement) {
              dynamicLoaded.value = true;
            }
            clientAgreementData.value = data.data;

            dynamicData.value = {
              data() {
                return {
                  firstName: clientAgreementData.value.client.firstname,
                  lastName: clientAgreementData.value.client.lastname,
                  address: clientAgreementData.value.client.address,
                  city: clientAgreementData.value.client.city,
                  state: clientAgreementData.value.client.state,
                  zipCode: clientAgreementData.value.client.zipCode,
                  today: ref(moment().format('LL')),
                  companyName: clientAgreementData.value.companyName,
                  company_address: clientAgreementData.value.company_address,
                  company_city: clientAgreementData.value.company_city,
                  company_state: clientAgreementData.value.company_state,
                  company_zipcode: clientAgreementData.value.company_zipcode,
                  consultation_fee: clientAgreementData.value.consultation_fee,
                  service_fee: clientAgreementData.value.service_fee,
                };
              },
              template: !userStore.user.is_contract_signed && clientAgreementData.value.service_agreement
                ? clientAgreementData.value.service_agreement
                : clientAgreementData.value.power_of_attorney,
            };
          }
        } catch (error) {
        }
      };

      fetchServiceAgreement();

      return {
        businessStore,
        userStore,
        clientAgreementData,
        dynamicData,
        dynamicLoaded,
        today,
        signature1,
        signature,
        state,
        route,
        router,
        isSavingInfo,
        signatureKey,
        type
      };
    },
    watch: {
        async 'signature1' (value) {
        }
    },
    methods:{
        handleMouseLeave(img) {
            this.signature = this.signature1.save(img);
        },
        save(t){
            let signature = this.signature1.save(t);
            this.signature = signature
            setTimeout(this.saveSignature(signature),3000);
        },
        saveSignature(signature){
            let $this = this;
            this.isSavingInfo = true
            const params ={
                upload_file:signature,
                date:this.today,
                htmlDocument:this.$refs.htmlDocument.innerHTML,
                type: this.type
            }
            const route = this.router.resolve({
                name: "client-uploadsignature",
            });
            axios.post(route.href,params).then(({data})=>{
                if(data.error == false){
                    $this.userStore.user.is_power_of_attorney_signed = true
                    $this.router.push({'name':'client-dashboard'})
                }
                this.isSavingInfo = false
                this.signatureKey++
            })
        },
        clear(){
            this.signature1.clear()
        },
        undo(){
            this.signature1.undo();
        },
        handleDisabled(){
            this.state.disabled = !this.state.disabled
        }
    }
  };
  </script>
  <style>
    .signature{
        width: 100% !important;
        height: 350px !important;
        border: 1px dotted silver;
    }
</style>
